var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OrbitSatellite"},[(_vm.modelUrl!='')?_c('model-gltf',{attrs:{"src":_vm.modelUrl,"lights":_vm.lights}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }